// extracted by mini-css-extract-plugin
export default {"container":"loading-planos_container__RFwNX","loading":"loading-planos_loading__vG1H7"};